import { Button, Col, Modal, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';
import PropTypes from 'prop-types';
import { MachineDeletionModalContent } from '../MachineDeletionModalContent';

export const MachineDeletionModal = ({
  onClose,
  visible,
  onDelete,
  loading,
  onOpenDataExportModal
}) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACES.MACHINE_DETAILS);

  return (
    <Modal
      title={t('deletionModal.title')}
      open={visible}
      className="base-modal no-select"
      closable={false}
      onCancel={onClose}
      width={550}
      destroyOnClose
      footer={[
        <Row>
          <Col md={12} className="text-left">
            <Button className="cancel-btn" onClick={onClose}>
              {t('exportCleaningReport.dialog.cancelButton')}
            </Button>
          </Col>

          <Col md={12} className="base-yellow-btn-col">
            <Button
              loading={loading}
              key="submit"
              className="submit-btn"
              onClick={onDelete}
              type="primary">
              {t('deletionModal.deleteButton')}
            </Button>
          </Col>
        </Row>
      ]}>
      <MachineDeletionModalContent onChangeFileType={onOpenDataExportModal} />
    </Modal>
  );
};

MachineDeletionModal.defaultProps = {
  loading: false
};

MachineDeletionModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onOpenDataExportModal: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  onDelete: PropTypes.func.isRequired
};
